import React, { ReactNode } from 'react';

interface SettingHeaderProps {
    action?: ReactNode;
    children: ReactNode;
}

const SettingHeader = ({ action, children }: SettingHeaderProps) => {
    return (
        <div className="flex h-13 items-center justify-between p-2">
            <h2 className="text-base font-bold">{children}</h2>
            {action}
        </div>
    );
};

export default SettingHeader;
